import { SORT_DIRECTIONS } from '../../constants/COLUMN_SORTER'

export const defaultSortOrder = (dataIndex: string, sortColumn: string, sortOrder: string) => {
  if (dataIndex !== sortColumn) {
    return ''
  }
  return sortOrder === SORT_DIRECTIONS.ASC ? 'ascend' : 'descend'
}
